import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Ripristina la posizione di scorrimento per URL (pathname+search) quando `ready`.
export function useScrollRestore(ready) {
  const location = useLocation();
  const key = `crm:scroll:${location.pathname}${location.search}`;

  useEffect(() => {
    if (!ready) return;
    const y = Number(sessionStorage.getItem(key) || 0);
    if (y > 0) requestAnimationFrame(() => window.scrollTo(0, y));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, key]);

  useEffect(() => {
    let t = null;
    const onScroll = () => {
      if (t) return;
      t = setTimeout(() => { t = null; try { sessionStorage.setItem(key, String(window.scrollY)); } catch {} }, 150);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => { window.removeEventListener("scroll", onScroll); if (t) clearTimeout(t); };
  }, [key]);
}
